<template lang="pug">
md-dialog#general-form-wrapper(:md-click-outside-to-close='false', :ref='dialogRef')
  md-dialog-title.md-headline {{ title }}
  md-dialog-content
    loader(:loading='creating', :size='45')
      slot
  md-dialog-actions.actions
    md-button.md-primary(@click='closeDialog') Cancel
    md-button.md-primary.md-raised(@click='save', :disabled='validationPending') Create
</template>

<script>
  import uuid from 'uuid';
  import Loader from '../../shared-components/Loader';

  export default {
    components: {
      Loader
    },
    props: {
      title: {
        type: String,
        default: 'Create'
      },
      validationPending: {
        type: Boolean,
        default: false
      },
      saveAction: {
        type: Function,
        required: true
      }
    },
    data() {
      return {
        creating: false,
        dialogRef: uuid.v4()
      };
    },
    methods: {
      closeDialog() {
        const ref = this.dialogRef;
        this.$refs[ref].close();
        this.$emit('closed');
      },
      openDialog() {
        const ref = this.dialogRef;
        this.$refs[ref].open();
      },
      async save() {
        this.creating = true;
        await this.saveAction()
          .then(() => {
            this.creating = false;
            this.closeDialog();
          })
          .catch(() => {
            this.creating = false;
          });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .actions {
    margin: 16px 16px 16px 0;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/forms/DialogForm.vue